<template>
  <div class="hello" style="background-color:#f5f5f5f8; height:auto; padding-bottom: 180px;">
    <van-sticky class="item-pop">
      <div style="position: relative; max-width: 640px; left:auto; margin: 0 auto;">
        <van-nav-bar style="height:40px;background: rgb(53, 120, 229)" :border="false" @click-left="onClickLeft">
          <template #left>
            <van-icon style=" font-weight: 900;" name="arrow-left" color="#FFFFFF" size="25"/>
          </template>
          <template #title>
            <span style="color:#FFFFFF; font-weight: 700; font-size: 19px;">訂單資料</span>
          </template>
        </van-nav-bar>
      </div>
    </van-sticky>
    <div style="max-width: 640px; background: rgb(53, 120, 229); left:auto; margin: 0 auto;height: 130px; border-radius: 0% 0% 50% 50%;">
      <div style="margin-left:15px; display: inline-flex">
      </div>
    </div>
    <van-cell-group style="border-radius:10px; margin-top:-100px; margin-left:20px; margin-right:20px;" :border="false">
      <van-cell style="border-radius:10px; height:auto;" size="large" :border="false">
        <template>
          <van-empty
            class="custom-image"
            image="/static/icon_done.svg"
            description="我們已經收到您的訂單~"
          />
      </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group style="border-radius:10px; margin-top: 10px; margin-left:20px; margin-right:20px;" :border="false">
      <van-cell style="border-radius:10px; height:auto;" size="large" :border="false">
        <template>
        <span class="Details-title">訂單詳情</span>
        <van-cell style=" border-radius:5px; height: 70px; background-color: #f5f5f5f8; margin-top: 10px;" :border="false">
          <template>
            <span>訂單編號：</span><span style="margin-left:5px;">{{ this.sn }}</span><br>
            <span>訂單日期：</span><span style="margin-left:5px;">{{ this.date }}</span>
          </template>
        </van-cell>
      </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group style="border-radius:10px; margin-top: 10px; margin-left:20px; margin-right:20px;" :border="false">
      <van-cell style="border-radius:10px; height:auto;" size="large" :border="false">
        <template>
        <span class="Details-title">商品清單</span>
         <van-cell v-for="(item,index) in list" :key="index" style=" min-height: 80px; background-color: #f5f5f5f8; margin-top: 10px;">
            <template #icon>
              <van-image style="position: relative; left: -10px; width:70px; height: 70px;"  :src="item.itemImg"/>
            </template>
            <template #title>
              <span style="position: relative; top: -10px; font-size: 14px;"> {{ item.itemTitle }}</span>
            </template>
            <template #label>
              <div style="position: relative; top: -15px; text-align:left;">
                <van-collapse v-model="activeNames"  :border="false">
                  <van-collapse-item :name="item.uid" style="border-radius:50px;">
                    <template #title>
                      <span style="font-size: 11px; margin-left: -15px;"> {{ item.packName }}</span>
                    </template>
                    <template>
                      <span style="font-size: 11px;"> {{ item.specsContent }}</span>
                    </template>
                  </van-collapse-item>
                </van-collapse>
              </div>
            </template>
            <template #right-icon>
              <span style="position:absolute; text-align: right; right: 10px; bottom: 0px; font-weight: 700; color: rgb(53, 120, 229)"> {{ item.currency }}$ {{ item.price }}</span>
            </template>
          </van-cell>
      </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group style="border-radius:10px; margin-left:20px; margin-right:20px; margin-bottom: 10px;" :border="false">
      <van-cell style=" height: 50px; background-color: #f5f5f5f8; margin-top: 10px;" :border="false">
        <template #title>
          <span style="position:absolute; text-align: right; right: 10px; top: 5px;"> 共計<span style="color: rgb(53, 120, 229); font-weight:700;">{{list.length}}</span>件商品</span>
        </template>
        <template #right-icon>
          <span style="position:absolute; text-align: right; right: 10px; top: 25px;"> 總價：<span style="color: rgb(53, 120, 229); font-weight:700;">NT$ {{price}}</span></span>
        </template>
      </van-cell>
    </van-cell-group>
      <van-cell-group style="border-radius:10px; margin-left:20px; margin-right:20px;" :border="false">
      <van-cell style="border-radius:10px; height:auto;" size="large" >
        <template>
        <span class="Details-title">配送資料</span>
        <van-cell style=" border-radius:5px; height: 70px; background-color: #f5f5f5f8; margin-top: 10px;" :border="false">
          <template>
            <div style="text-align:center; display:flex; align-items: center;">
              <span>配送方式</span>
              <div style="width: 150px; height: 50px; background-color: rgb(53, 120, 229); margin-left:10px; margin-top:15px;">
                  <div style="text-align:center; display:flex; align-items: center; margin-top:5px;  margin-left: 30px;">
                  <van-image v-if="express == '新竹物流'" width="20px" height="20px" src="./static/icon_car.svg"/>
                  <van-image v-else-if="express == '7-11'" width="20px" height="20px" src="./static/icon_store.svg"/>
                  <van-image v-else-if="express == '全家'" width="20px" height="20px" src="./static/icon_quanjia.svg"/>
                  <span style="color:#FFFFFF; font-weight:500;">{{ express }}</span>
                </div>
              </div>

            </div>
          </template>
        </van-cell>
        <van-cell style=" border-radius:5px; height: 90px; background-color: #f5f5f5f8; margin-top: 10px;" :border="false">
        <template #title>
          <span style="position:relative; top: -10px; left: -8px; font-size:14px;">收貨資料</span>
        </template>
        <template #label>
          <div>
            <span style="position:relative; top: -10px; left: -8px; font-size:14px; font-weight: 400;">{{ addrInfo.name }} {{ addrInfo.tel }}</span><br>
            <span style="position:relative; top: -10px; left: -8px; font-size:11px; ">{{ addrInfo.address }}</span>
          </div>
        </template>
      </van-cell>
      <van-cell style=" border-radius:5px; height: 60px; background-color: #f5f5f5f8; margin-top: 10px;" :border="false">
        <template #title>
          <span style="position:relative; top: -10px; left: -8px; font-size:14px;">付款方式</span>
          <van-radio-group v-model="payment" disable>
            <van-radio name="1" shape="square" checked>貨到付款</van-radio>
          </van-radio-group>
        </template>
      </van-cell>
      <van-cell style=" border-radius:5px; height: 140px; background-color: #f5f5f5f8; margin-top: 10px;" :border="false">
        <template #title>
          <span style="position:relative; top: -10px; left: -8px; font-size:14px;">訂單留言</span>
          <van-field
            v-model="memo"
            rows="2"
            autosize
            readonly
            height="60px"
            type="textarea"
            maxlength="50"
            placeholder="暫無留言"
            show-word-limit
          />
        </template>
      </van-cell>
      </template>
      </van-cell>
    </van-cell-group>
    <van-popup
      class="item-pop"
      v-model="showPicker"
      closeable
      position="bottom"
      :style="{ height: '95%'}"
    >
      <template>
        <div style="margin-left:10px; margin-top:15px;">
          <span>請選擇收貨資料</span>
        </div>
        <div style="padding-bottom: 120px;">
          <van-cell-group style=" margin-top:10px; margin-right: 10px; margin-left: 10px;" :border="false">
            <van-cell  style="margin-top:10px;" v-for="(item,index) in addrList" :key= "index" size="large" :border="false" is-link center @click="onSelect(index,item.id)">
              <template #title>
                <span style="font-size:16px;">{{item.name + ' ' + item.tel}}</span>
              </template>
              <template #label>
                <span style="font-size:12px;">{{item.address}}</span>
              </template>
              <template  #right-icon>
                <van-icon name="arrow" color="#969799" size="20px" />
              </template>
            </van-cell>
            <template #right>
              <van-button square type="danger" text="刪除" class="delete-button" />
            </template>
          </van-cell-group>
        </div>
        <div>
          <van-button style="position: fixed; max-width: 640px; min-width: 320px; bottom: 0px;" square  type="primary" size="large" color="rgb(53, 120, 229)" to="/address/add">新增地址</van-button>
        </div>
      </template>
    </van-popup>
  </div>
</template>
<script>
import { Toast } from 'vant'

export default {
  name: 'HelloWorld',
  components: {
  },
  data () {
    return {
      type: 0,
      express: '',
      payment: '1',
      activeNames: ['1'],
      sn: '',
      date: '',
      showPicker: false,
      addrId: undefined,
      addrInfo: {},
      addrList: [],
      price: 0,
      list: [],
      memo: '',
      recomm: []
    }
  },
  created () {
  },
  mounted () {
    this.list = JSON.parse(this.$route.query.list)
    this.addrInfo = JSON.parse(this.$route.query.addrInfo)
    this.type = this.$route.query.type
    this.express = this.$route.query.express
    this.memo = this.$route.query.memo
    this.sn = this.$route.query.sn
    this.date = this.$route.query.date
    for (var i = 0; i < this.list.length; i++) {
      this.price += parseInt(this.list[i].price)
    }

    this.date = this.timeToTimestamp(this.date)
  },
  methods: {
    onClickLeft () {
      this.$router.replace('/')
      window.scrollTo(0, 0)
    },
    timeToTimestamp (time) {
      let date = new Date(time)
      console.log(date.getFullYear() - 1911)
      console.log(date.getMonth())
      console.log(date.getDate())
      console.log(date.getHours())
      console.log(date.getMinutes())
      console.log(date.getSeconds())
      var dateset = date.getFullYear() - 1911 + '年' + (date.getMonth() + 1).toString().padStart(2, '0') + '月' + (date.getDate() + 1).toString().padStart(2, '0') + '日' + (date.getHours()).toString().padStart(2, '0') + ':' + (date.getMinutes()).toString().padStart(2, '0') + ':' + (date.getSeconds()).toString().padStart(2, '0')
      console.log(dateset)
      return dateset
    },
    gotoItem (link) {
      window.scrollTo(0, 0)
      this.$router.replace({ path: '/' + link })
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 200
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Price-title {
    margin-right: 4px;
    vertical-align: middle;
    color: #3578e5;
    float: left;
    font-weight: 700;
    font-size: 24px;
  }
  .van-empty >>> .van-empty__image {
    width: 50px !important;
    height: 50px !important;
  }
  .item-pop {
    left:auto;
    height: 95%;
    min-width: 320px;
    max-width:640px;
    background-color:#f4f5f5;
  }
  .recomm-cell{
  border-radius:20px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 0px !important;
  }
  .recomm-cell .van-grid >>>.van-grid-item__content {
  padding-top: 2px !important;
  padding-left: 8px !important;
  }
  .typeCard {
    margin-top:10px;
  }
  .typeCard>>>.van-tabs__wrap {
    height: 40px !important;
  }

  .typeCard>>>.van-tabs__nav--card {
    height: 40px !important;
  }
  .action-bar {
    position: fixed;
    left:auto;
    max-width:640px;
    margin:0 auto;
    z-index:1000;
  }
  .action-button {
    color: #FFFFFF;
    background-color:rgb(53, 120, 229);
    width: 40%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Success.vue